export default __webpack_public_path__ + "static/media/banner.11b5562d.svg";